export const supportedLanguages = [
  { code: 'en', language: 'English', country: 'United States' },
  {
    code: 'fr',
    language: 'Français',
    country: 'France',
  },
];
